// App.tsx
import { Suspense } from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import router from './routes/'
import { Theme } from './theme/theme';

export function App() {
  const content = useRoutes(router)

  return (
    <Theme>
      <Suspense>{content}</Suspense>
    </Theme>
  );
};

export default App;
